export default __webpack_public_path__ + "static/media/meghana.6d56b4f8.jpg";